import { Link } from 'react-router-dom'
import { Typography } from '@mui/material'
import { useDispatch } from 'react-redux'
import styles from './plannerCardStyle.module.scss'
import ButtonCustom from '../button/ButtonCustom'
import { openModal, setModalData } from '../../../features/commonSlice'

const PlannerCardList = ({ data }) => {
	const dispatch = useDispatch()

	const handleFavoriteClick = (e) => {
		e.preventDefault()
		e.stopPropagation()
		dispatch(openModal('addFavoritePlannerModal'))
		dispatch(setModalData({ plannerId: data._id }))
	}
	return (
		<Link className={styles.plannerCardList} to={`/profile/${data._id}`}>
			<div className={styles.card}>
				<div className={styles.cardImg}>
					<img
						src={
							data.businessProfilePic ||
							'/images/ontimebride_iconset_blue_vendor_default.png'
						}
						alt="business_profile"
					/>
                    {
                        data.topPlanner &&
                        <span className={styles.topLabel}>
                            <img
                                src="/images/vendor-feat-label.svg"
                                alt="planner-feat-label.svg"
                            />
                            Top Planner
                        </span>
                    }
				</div>
				<div className={styles.cardDetails}>
					<div
						style={{
							display: 'flex',
							alignItems: 'start',
							gap: '12px',
						}}
					>
						<div className={styles.nameAndReview}>
							<div className={styles.review}>
								<Typography variant="h4">
									{data.businessType || 'Wedding Planner'}
								</Typography>
								<ul className={styles.rating}>
									{[1, 2, 3, 4, 5].map((star) => (
										<li key={star}>
											<img
												src={
													star <= Math.round(data.avgRating || 0)
														? '/images/star.svg'
														: '/images/star-without-fill.svg'
												}
												alt="star.svg"
											/>
										</li>
									))}
								</ul>
							</div>
							<Typography
								variant="h3"
								className={styles.plannerName}
							>
								{data.businessName}
							</Typography>
						</div>
						<ButtonCustom
							variant="outlined"
							size="sm"
							style={{
								padding: '8px',
							}}
							onClick={handleFavoriteClick}
						>
							<img src="/images/heart.svg" alt="heart" />
						</ButtonCustom>
					</div>
					<div className={styles.location}>
						<img src="/images/location.svg" alt="location" />
						<span>{data.businessAddress}</span>
					</div>
				</div>
			</div>
		</Link>
	)
}

export default PlannerCardList
